import {forwardRef, PropsWithChildren} from "react";
import {createGlobalStyle} from "styled-components";
import {View} from "@unibuddy/patron";
import {ChatInput} from "@unibuddy/chat-ui";

// This is a workaround to handle when the browser font size is increased above the default
// setting the width on the textarea should be done in the chat-ui package
const FixTextArea = createGlobalStyle`
  #chat-input-improved textarea {
    width: 100%;
  }
`;

export const ChatInputImproved = forwardRef<
    HTMLTextAreaElement,
    PropsWithChildren<{onSend: () => void}>
>(({onSend, ...props}, ref) => {
    return (
        <View flex={1} id="chat-input-improved">
            <FixTextArea />
            <ChatInput ref={ref} onSend={onSend} {...props} />
        </View>
    );
});
